import axios from 'axios';
import Utils from '@/common/utils';

export default {
  search: function (request) {
    return axios.get('/api/journalImar/search', { params: request })
  },
  find: function (id) {
    return axios.get('/api/journalImar/find?id='+id)
  },
  save: function (data) {
    return axios.post('/api/journalImar/save', data)
  },
  delete: function (id) {
    return axios.delete('/api/journalImar/delete?id='+id)
  },
  loadOrganizations: function(serviceTypeId) {
    return axios.get('/api/organizations/getList?serviceTypeId=' + serviceTypeId)
  },
  loadEmployees: function(orgId) {
    return axios.get('/api/organizations/getEmployeeList?organizationId=' + orgId)
  },
  loadAddresses: function(orgId) {
    return axios.get('/api/organizations/getAddressList?organizationId=' + orgId)
  },
  loadOrganizationsOnMap: function (serviceTypeId) {
    return axios.get('/api/organizations/search', { params: {isShowMap: true, serviceTypeId: serviceTypeId} })
  },
  saveVisit: function (data) {
    return axios.post('/api/journalImar/saveVisit', data)
  },
  exportPdf: function (routeId) {
    return Utils.downloadFile('/api/journalImar/exportPdf/' + routeId, "ImarRoute.pdf");    
  }
}